import { MembershipEntity, ProductManagerCandidate } from '@data';
import { Roles, normalizeRole } from '@app/utils/types';

/** One person the incident's hours can be booked to. */
export interface ReportPerson {
  userId: string;
  name: string;
  /** Has an involvement on the product the time is booked to. */
  onTeam: boolean;
  /** The person doing the booking, whose own day this is. */
  isYou: boolean;
  /** The chapter their work is filed under, when they have chosen one that is still in use. */
  chapter?: string;
}

const fullName = (member: MembershipEntity): string =>
  `${member.user.firstName ?? ''} ${member.user.lastName ?? ''}`.trim() || member.user.email;

/** Who an incident's hours can be booked to. Deactivated people stay, unlike elsewhere: they still spent the hours. */
export const peopleForProduct = (
  members: MembershipEntity[],
  team: ProductManagerCandidate[],
  yourUserId?: string,
): ReportPerson[] => {
  const onTeam = new Set(team.map(person => person.membershipId));

  return members
    .filter(member => normalizeRole(member.role) !== Roles.client && !!member.user.id)
    .map(member => ({
      userId: member.user.id as string,
      name: fullName(member),
      onTeam: onTeam.has(member.id),
      isYou: !!yourUserId && member.user.id === yourUserId,
      // A retired chapter cannot take a new involvement, so it is no answer: the product's own is asked instead.
      chapter: member.defaultChapter?.isActive ? member.defaultChapter.key : undefined,
    }))
    .sort((a, b) => Number(b.onTeam) - Number(a.onTeam) || a.name.localeCompare(b.name));
};
